<template>
  <div class="reports-container">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.reports-container {
  min-height: calc(100vh - 130px);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin: 30px 30px 0 30px;
  
  @media (min-width: 768px) {
    padding: 20px;
    background-color: $color-white;
  }

  @media (max-width: 768px) {
    margin: 10px 10px 0 10px;
  }
}
</style>
